import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContactFieldsState, DocumentFieldsState } from './documentfields.reducer';
import { CONTACT_FIELDS_FEATURE_KEY, DOCUMENT_FIELDS_FEATURE_KEY } from './documentfields.config';

export const selectDocumentFieldsState =
  createFeatureSelector<DocumentFieldsState>(DOCUMENT_FIELDS_FEATURE_KEY);

export const selectContactFieldsState =
  createFeatureSelector<ContactFieldsState>(CONTACT_FIELDS_FEATURE_KEY);

  export const selectAllDocumentFields = createSelector(
  selectDocumentFieldsState,
  (state) => state.documentFields
);

export const selectDocumentFieldsLoading = createSelector(
  selectDocumentFieldsState,
  (state) => state.loading
);

export const selectDocumentFieldsError = createSelector(
  selectDocumentFieldsState,
  (state) => state.error
);

export const selectAllContactFields = createSelector(
  selectContactFieldsState,
  (state) => state.contactFields
);

export const selectContactFieldsLoading = createSelector(
  selectContactFieldsState,
  (state) => state.loading
);

export const selectContactFieldsError = createSelector(
  selectContactFieldsState,
  (state) => state.error
);

export const selectContactFieldsStale = createSelector(
  selectContactFieldsState,
  (state) => state.stale
);